import React from 'react'
import NextLink from 'next/link'

import { Sheet, SheetOverlay, SheetContent } from '@wartek-id/sheet-v1'
import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon'

import { useAPIJenjangSelection } from 'api/assessment/useAPIJenjangSelection'

interface JenjangSelectionSheetProps {
  isOpen: boolean
  onClose: () => void
}

const JenjangSelectionSheet = (props: JenjangSelectionSheetProps) => {
  const { data: jenjangSelections } = useAPIJenjangSelection()
  return (
    <Sheet sheetSize="auto" {...props}>
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <div className="flex flex-row items-center justify-between p-4">
          <Text variant="body">Pilih Jenjang</Text>
          <Button variant="ghost" onClick={props?.onClose}>
            <Icon>close</Icon>
          </Button>
        </div>
        {jenjangSelections?.map((jenjang) => (
          <NextLink key={jenjang.label} href={jenjang.url} passHref>
            <a className="block p-4 hover:bg-gray-10">
              <Text variant="heading-sm" className="flex items-center gap-x-2">
                {jenjang.label}
              </Text>
            </a>
          </NextLink>
        ))}
      </SheetContent>
    </Sheet>
  )
}

export default JenjangSelectionSheet
